var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 306,
    viewBox: "0 0 300 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 306,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop - 132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2816,
    height: 1024,
    transform: "translate(-1679 -107.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 397"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tree"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M186.794 299.584C192.118 290.12 203.215 268.399 204.848 262.624C211.876 237.765 207.904 215.009 204.848 203.878C201.792 192.747 193.38 174.667 179.653 151.653C165.925 128.638 154.843 96.7414 149.898 87.1392C144.952 77.537 97.2152 51.4324 86.5275 45.2844L75.8398 39.1445",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M259.058 23.0117C259.058 23.0117 237.675 44.9018 226.223 59.4951C214.771 74.0885 184.614 135.536 184.614 135.536C184.614 135.536 202.942 164.723 210.573 180.837C218.205 196.951 226.609 219.229 226.609 239.202C226.609 259.175 226.987 278.371 226.987 287.965C226.987 292.148 228.362 296.548 229.914 300.18",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M196.661 26.5724L195.302 95.9718L194.184 97.7434L176.958 125.523C176.958 125.523 173.46 119.997 166.689 105.186C158.872 88.0765 147.099 59.8848 147.485 56.4306C147.871 52.9764 178.905 21.0959 180.818 18.4102",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M81.5493 38.3743C81.5493 38.3743 137.666 69.8585 141.477 70.627C145.289 71.3955 121.252 24.9297 121.252 24.9297",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M126.978 24.5506C126.978 24.5506 141.454 44.9036 143.392 46.8208C145.33 48.738 175.455 17.2539 175.455 17.2539",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M226.223 5.73438L231.185 44.135L259.822 15.7168",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M200.473 20.8126L205.008 79.7119L226.03 46.3105L223.103 0.5",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M218.206 302.182C218.206 302.182 217.554 297.239 220.506 285.696C223.457 274.152 225.419 253.378 223.779 237.879",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M220.505 246.121C220.837 253.172 220.505 260.238 219.516 267.226",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M216.573 263.602C216.435 269.386 215.664 275.137 214.273 280.751C211.981 289.981 210.011 293.937 210.011 293.937",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M217.224 203.91C217.224 203.91 221.487 218.754 222.468 225.679",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M218.535 227.328C218.535 227.328 219.516 236.89 219.846 239.527",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M207.719 179.509L193.292 153.453",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M196.573 163.68L183.457 143.238",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Floor"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M255.657 301.138L250.004 298.016L243.956 301.251L237.909 298.016L231.861 301.251L225.806 298.016L219.758 301.251L213.711 298.016L207.663 301.251L201.616 298.016L195.568 301.251L189.521 298.016L183.473 301.251L177.426 298.016L171.258 301.615L165.339 298.016L159.291 301.251L153.244 298.016L147.196 301.251L141.157 298.016L135.109 301.251L129.07 298.016L123.022 301.251L116.983 298.016L110.936 301.251L104.888 298.016L98.8405 301.251L92.793 298.016L86.7536 301.251L80.706 298.016L74.6585 301.251L68.611 298.016L62.5635 301.251L56.5241 298.016L50.4766 301.251L44.4291 298.016L38.3816 301.251L32.3421 298.016L19.2097 305.102H264.214L255.657 301.138Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    opacity: 0.5,
    d: "M255.657 301.138L250.004 298.016L243.956 301.251L237.909 298.016L231.861 301.251L225.806 298.016L219.758 301.251L213.711 298.016L207.663 301.251L201.616 298.016L195.568 301.251L189.521 298.016L183.473 301.251L177.426 298.016L171.258 301.615L165.339 298.016L159.291 301.251L153.244 298.016L147.196 301.251L141.157 298.016L135.109 301.251L129.07 298.016L123.022 301.251L116.983 298.016L110.936 301.251L104.888 298.016L98.8405 301.251L92.793 298.016L86.7536 301.251L80.706 298.016L74.6585 301.251L68.611 298.016L62.5635 301.251L56.5241 298.016L50.4766 301.251L44.4291 298.016L38.3816 301.251L32.3421 298.016L19.2097 305.102H264.214L255.657 301.138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M26.2942 301.251L32.3417 298.016L38.3811 301.251L44.4286 298.016L50.4762 301.251L56.5237 298.016L62.5631 301.251L68.6106 298.016L74.6581 301.251L80.7056 298.016L86.7531 301.251L92.7926 298.016L98.8401 301.251L104.888 298.016L110.935 301.251L116.983 298.016L123.022 301.251L129.07 298.016L135.109 301.251L141.156 298.016L147.196 301.251L153.243 298.016L159.291 301.251L165.338 298.016L171.378 301.251L177.425 298.016L183.473 301.251L189.52 298.016L195.568 301.251L201.615 298.016L207.663 301.251L213.71 298.016L219.758 301.251L225.805 298.016L231.861 301.251L237.908 298.016L243.956 301.251L250.003 298.016L256.051 301.251L262.098 298.016L268.154 301.251",
    stroke: "#263238",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M16.4434 305.047H257.394",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Wind"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M129.68 104.945C121.188 110.713 112.438 117.435 103.681 120.493C88.4011 125.848 67.7657 123.171 50.4756 107.785",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M178.157 105.778C178.157 105.778 165.523 93.7412 150.895 95.076C146.07 95.5209 141.068 97.8102 135.945 100.892",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M55.3972 120.801C54.1909 119.863 52.9847 118.876 51.8105 117.824",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M111.272 127.748C109.251 128.814 107.158 129.736 105.008 130.507C91.8271 135.118 74.7059 133.742 59.1689 123.469",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M248.065 178.309C243.007 181.747 237.788 185.751 232.568 187.579C223.457 190.766 211.169 189.197 200.859 180.007",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M276.96 178.811C276.96 178.811 269.433 171.636 260.715 172.428C257.836 172.695 254.853 174.046 251.805 175.891",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M203.835 187.756C203.111 187.206 202.395 186.607 201.696 185.984",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M237.096 191.916C235.892 192.544 234.645 193.085 233.364 193.534C225.507 196.284 215.302 195.484 206.022 189.344",
    stroke: "#263238",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Leaves"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M87.8391 139.009C88.1406 139.747 88.6183 140.399 89.2299 140.907C89.8414 141.415 90.568 141.763 91.3454 141.921C93.9429 142.366 97.3044 140.595 97.3044 140.595C95.742 139.299 93.9605 138.296 92.045 137.634C91.2857 137.466 90.4956 137.505 89.7562 137.746C89.0168 137.988 88.355 138.424 87.8391 139.009Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M114.007 69.0654C114.007 69.0654 110.79 65.8296 106.448 67.0673C102.105 68.3049 98.0923 73.4741 98.0923 73.4741C98.0923 73.4741 104.059 75.092 108.442 74.283C112.825 73.4741 114.007 69.0654 114.007 69.0654Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M169.56 186.05C169.56 186.05 166.343 182.814 162.001 184.052C157.658 185.289 153.637 190.458 153.637 190.458C153.637 190.458 159.612 192.076 163.987 191.267C168.362 190.458 169.56 186.05 169.56 186.05Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M83.7776 60.7422C83.7776 60.7422 79.5314 62.2468 78.7272 66.7446C77.923 71.2423 80.8744 77.091 80.8744 77.091C80.8744 77.091 84.8954 72.3586 86.0534 68.0389C87.2114 63.7191 83.7776 60.7422 83.7776 60.7422Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M107.059 216.602C107.059 216.602 102.813 218.114 102.001 222.604C101.189 227.094 104.116 232.95 104.116 232.95C104.116 232.95 108.137 228.218 109.295 223.898C110.453 219.578 107.059 216.602 107.059 216.602Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M160.521 61.1967C160.822 61.9346 161.3 62.5864 161.912 63.0943C162.523 63.6023 163.25 63.9507 164.027 64.1089C166.625 64.5538 169.994 62.7822 169.994 62.7822C168.428 61.4868 166.644 60.4841 164.727 59.8215C163.968 59.6533 163.177 59.6921 162.438 59.9339C161.699 60.1757 161.037 60.6116 160.521 61.1967Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M125.475 53.2351C125.776 53.972 126.252 54.6231 126.862 55.131C127.472 55.6389 128.197 55.9879 128.973 56.1473C131.579 56.5922 134.94 54.8206 134.94 54.8206C133.376 53.5236 131.591 52.5207 129.673 51.8599C128.915 51.6924 128.126 51.7316 127.388 51.9733C126.65 52.2151 125.99 52.6507 125.475 53.2351Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M53.1299 215.771C53.4306 216.508 53.9071 217.16 54.5172 217.667C55.1272 218.175 55.8522 218.524 56.6281 218.684C59.2337 219.121 62.5952 217.357 62.5952 217.357C62.5952 217.357 59.8368 215.043 57.3278 214.388C56.569 214.223 55.7802 214.265 55.0425 214.508C54.3048 214.751 53.6447 215.187 53.1299 215.771Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M175.914 39.4452C175.914 39.4452 177.152 43.7973 181.543 44.8813C185.934 45.9653 191.941 43.3524 191.941 43.3524C191.941 43.3524 187.486 39.0407 183.272 37.6089C179.058 36.1771 175.914 39.4452 175.914 39.4452Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M109.439 29.8655C109.439 29.8655 110.678 34.2176 115.069 35.3016C119.459 36.3856 125.467 33.7808 125.467 33.7808C125.467 33.7808 121.003 29.4286 116.822 27.9968C112.64 26.565 109.439 29.8655 109.439 29.8655Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M206.047 20.4082C206.047 20.4082 205.556 24.906 209.264 27.5917C212.971 30.2774 219.461 30.1398 219.461 30.1398C219.461 30.1398 216.968 24.4772 213.606 21.5165C210.245 18.5558 206.047 20.4082 206.047 20.4082Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M55.6873 104.185C55.6873 104.185 54.7625 99.7524 50.444 98.3448C46.1255 96.9372 39.9895 99.089 39.9895 99.089C39.9895 99.089 44.115 103.724 48.2083 105.464C52.3016 107.203 55.6873 104.185 55.6873 104.185Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M189.167 18.2899C189.167 18.2899 188.25 13.8488 183.932 12.4412C179.613 11.0337 173.477 13.1935 173.477 13.1935C173.477 13.1935 177.594 17.8288 181.696 19.568C185.797 21.3073 189.167 18.2899 189.167 18.2899Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M54.0952 67.3443C54.0952 67.3443 53.1704 62.9113 48.8519 61.5037C44.5334 60.0962 38.3975 62.256 38.3975 62.256C38.3975 62.256 42.523 66.8832 46.6163 68.6305C50.7096 70.3778 54.0952 67.3443 54.0952 67.3443Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    opacity: 0.3,
    d: "M54.0952 67.3443C54.0952 67.3443 53.1704 62.9113 48.8519 61.5037C44.5334 60.0962 38.3975 62.256 38.3975 62.256C38.3975 62.256 42.523 66.8832 46.6163 68.6305C50.7096 70.3778 54.0952 67.3443 54.0952 67.3443Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M158.961 124.786C158.961 124.786 158.044 120.353 153.726 118.945C149.407 117.538 143.271 119.697 143.271 119.697C143.271 119.697 147.389 124.325 151.49 126.072C155.592 127.819 158.961 124.786 158.961 124.786Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    opacity: 0.3,
    d: "M158.961 124.786C158.961 124.786 158.044 120.353 153.726 118.945C149.407 117.538 143.271 119.697 143.271 119.697C143.271 119.697 147.389 124.325 151.49 126.072C155.592 127.819 158.961 124.786 158.961 124.786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M111.876 98.0778C111.876 98.0778 107.855 95.9664 104.067 98.4095C100.279 100.852 97.9551 107.017 97.9551 107.017C97.9551 107.017 104.131 106.774 108.08 104.711C112.028 102.648 111.876 98.0778 111.876 98.0778Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    opacity: 0.3,
    d: "M111.876 98.0778C111.876 98.0778 107.855 95.9664 104.067 98.4095C100.279 100.852 97.9551 107.017 97.9551 107.017C97.9551 107.017 104.131 106.774 108.08 104.711C112.028 102.648 111.876 98.0778 111.876 98.0778Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M240.329 170.137C240.329 170.137 244.06 172.678 248.137 170.663C252.215 168.649 255.134 162.776 255.134 162.776C255.134 162.776 248.966 162.339 244.824 163.965C240.682 165.591 240.329 170.137 240.329 170.137Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    opacity: 0.3,
    d: "M240.329 170.137C240.329 170.137 244.06 172.678 248.137 170.663C252.215 168.649 255.134 162.776 255.134 162.776C255.134 162.776 248.966 162.339 244.824 163.965C240.682 165.591 240.329 170.137 240.329 170.137Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M255.408 53.8601C255.408 53.8601 259.139 56.4002 263.216 54.3859C267.294 52.3716 270.213 46.4987 270.213 46.4987C270.213 46.4987 264.045 46.0618 259.903 47.6878C255.762 49.3138 255.408 53.8601 255.408 53.8601Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    opacity: 0.3,
    d: "M255.408 53.8601C255.408 53.8601 259.139 56.4002 263.216 54.3859C267.294 52.3716 270.213 46.4987 270.213 46.4987C270.213 46.4987 264.045 46.0618 259.903 47.6878C255.762 49.3138 255.408 53.8601 255.408 53.8601Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M144.261 18.89C144.261 18.89 140.28 16.7705 136.444 19.2216C132.608 21.6727 130.34 27.8207 130.34 27.8207C130.34 27.8207 136.508 27.578 140.457 25.5152C144.406 23.4524 144.261 18.89 144.261 18.89Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    opacity: 0.3,
    d: "M144.261 18.89C144.261 18.89 140.28 16.7705 136.444 19.2216C132.608 21.6727 130.34 27.8207 130.34 27.8207C130.34 27.8207 136.508 27.578 140.457 25.5152C144.406 23.4524 144.261 18.89 144.261 18.89Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M116.741 41.3431C116.741 41.3431 112.76 39.2236 108.932 41.6747C105.104 44.1258 102.821 50.2738 102.821 50.2738C102.821 50.2738 108.997 50.0311 112.945 47.9683C116.894 45.9055 116.741 41.3431 116.741 41.3431Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    opacity: 0.3,
    d: "M116.741 41.3431C116.741 41.3431 112.76 39.2236 108.932 41.6747C105.104 44.1258 102.821 50.2738 102.821 50.2738C102.821 50.2738 108.997 50.0311 112.945 47.9683C116.894 45.9055 116.741 41.3431 116.741 41.3431Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M97.9638 34.3945C97.9638 34.3945 94.8757 37.695 96.2026 42.0633C97.5295 46.4316 102.821 50.2741 102.821 50.2741C102.821 50.2741 104.228 44.2232 103.304 39.8468C102.379 35.4704 97.9638 34.3945 97.9638 34.3945Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    opacity: 0.3,
    d: "M97.9638 34.3945C97.9638 34.3945 94.8757 37.695 96.2026 42.0633C97.5295 46.4316 102.821 50.2741 102.821 50.2741C102.821 50.2741 104.228 44.2232 103.304 39.8468C102.379 35.4704 97.9638 34.3945 97.9638 34.3945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M51.0391 27.9869C51.0391 27.9869 51.0793 32.517 55.06 34.7497C59.0407 36.9824 65.5145 36.0682 65.5145 36.0682C65.5145 36.0682 62.2977 30.7211 58.6386 28.2458C54.9796 25.7704 51.0391 27.9869 51.0391 27.9869Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    opacity: 0.3,
    d: "M51.0391 27.9869C51.0391 27.9869 51.0793 32.517 55.06 34.7497C59.0407 36.9824 65.5145 36.0682 65.5145 36.0682C65.5145 36.0682 62.2977 30.7211 58.6386 28.2458C54.9796 25.7704 51.0391 27.9869 51.0391 27.9869Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M53.8862 47.9133C53.8862 47.9133 58.2368 49.0781 61.4214 45.8343C64.606 42.5904 65.4424 36.0703 65.4424 36.0703C65.4424 36.0703 59.4753 37.6882 56.0896 40.6004C52.704 43.5126 53.8862 47.9133 53.8862 47.9133Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    opacity: 0.3,
    d: "M53.8862 47.9133C53.8862 47.9133 58.2368 49.0781 61.4214 45.8343C64.606 42.5904 65.4424 36.0703 65.4424 36.0703C65.4424 36.0703 59.4753 37.6882 56.0896 40.6004C52.704 43.5126 53.8862 47.9133 53.8862 47.9133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M227.156 68.6464C227.156 68.6464 231.137 66.527 231.282 61.9645C231.426 57.4021 227.647 52.0469 227.647 52.0469C227.647 52.0469 224.374 57.3131 223.851 61.7542C223.328 66.1953 227.156 68.6464 227.156 68.6464Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    opacity: 0.3,
    d: "M227.156 68.6464C227.156 68.6464 231.137 66.527 231.282 61.9645C231.426 57.4021 227.647 52.0469 227.647 52.0469C227.647 52.0469 224.374 57.3131 223.851 61.7542C223.328 66.1953 227.156 68.6464 227.156 68.6464Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M243.401 56.9316C243.401 56.9316 242.428 52.5067 238.093 51.1558C233.759 49.8048 227.639 52.0456 227.639 52.0456C227.639 52.0456 231.821 56.6242 235.938 58.3149C240.056 60.0056 243.401 56.9316 243.401 56.9316Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    opacity: 0.3,
    d: "M243.401 56.9316C243.401 56.9316 242.428 52.5067 238.093 51.1558C233.759 49.8048 227.639 52.0456 227.639 52.0456C227.639 52.0456 231.821 56.6242 235.938 58.3149C240.056 60.0056 243.401 56.9316 243.401 56.9316Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M206.078 30.3284C206.078 30.3284 206.126 34.8584 210.099 37.083C214.072 39.3076 220.554 38.4097 220.554 38.4097C220.554 38.4097 217.409 33.0545 213.726 30.5387C210.043 28.0229 206.078 30.3284 206.078 30.3284Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    opacity: 0.3,
    d: "M206.078 30.3284C206.078 30.3284 206.126 34.8584 210.099 37.083C214.072 39.3076 220.554 38.4097 220.554 38.4097C220.554 38.4097 217.409 33.0545 213.726 30.5387C210.043 28.0229 206.078 30.3284 206.078 30.3284Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M208.925 50.245C208.925 50.245 213.284 51.418 216.468 48.166C219.653 44.9141 220.489 38.4102 220.489 38.4102C220.489 38.4102 214.522 40.028 211.128 42.9322C207.735 45.8363 208.925 50.245 208.925 50.245Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    opacity: 0.3,
    d: "M208.925 50.245C208.925 50.245 213.284 51.418 216.468 48.166C219.653 44.9141 220.489 38.4102 220.489 38.4102C220.489 38.4102 214.522 40.028 211.128 42.9322C207.735 45.8363 208.925 50.245 208.925 50.245Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M126.367 58.2346C126.367 58.2346 126.407 62.7647 130.388 64.9893C134.369 67.2139 140.843 66.316 140.843 66.316C140.843 66.316 137.698 60.9607 134.015 58.4449C130.332 55.9291 126.367 58.2346 126.367 58.2346Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    opacity: 0.3,
    d: "M126.367 58.2346C126.367 58.2346 126.407 62.7647 130.388 64.9893C134.369 67.2139 140.843 66.316 140.843 66.316C140.843 66.316 137.698 60.9607 134.015 58.4449C130.332 55.9291 126.367 58.2346 126.367 58.2346Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M129.214 78.1513C129.214 78.1513 133.565 79.3161 136.757 76.0723C139.95 72.8284 140.778 66.3164 140.778 66.3164C140.778 66.3164 134.811 67.9343 131.426 70.8384C128.04 73.7425 129.214 78.1513 129.214 78.1513Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    opacity: 0.3,
    d: "M129.214 78.1513C129.214 78.1513 133.565 79.3161 136.757 76.0723C139.95 72.8284 140.778 66.3164 140.778 66.3164C140.778 66.3164 134.811 67.9343 131.426 70.8384C128.04 73.7425 129.214 78.1513 129.214 78.1513Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M167.646 67.4574C167.646 67.4574 166.376 63.1134 161.953 62.0617C157.53 61.0101 151.571 63.6796 151.571 63.6796C151.571 63.6796 156.05 67.959 160.272 69.3422C164.494 70.7255 167.646 67.4574 167.646 67.4574Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    opacity: 0.3,
    d: "M167.646 67.4574C167.646 67.4574 166.376 63.1134 161.953 62.0617C157.53 61.0101 151.571 63.6796 151.571 63.6796C151.571 63.6796 156.05 67.959 160.272 69.3422C164.494 70.7255 167.646 67.4574 167.646 67.4574Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M159.468 49.0859C159.468 49.0859 154.965 49.1587 152.777 53.1307C150.59 57.1026 151.555 63.6469 151.555 63.6469C151.555 63.6469 156.847 60.4112 159.315 56.7143C161.784 53.0174 159.468 49.0859 159.468 49.0859Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    opacity: 0.3,
    d: "M159.468 49.0859C159.468 49.0859 154.965 49.1587 152.777 53.1307C150.59 57.1026 151.555 63.6469 151.555 63.6469C151.555 63.6469 156.847 60.4112 159.315 56.7143C161.784 53.0174 159.468 49.0859 159.468 49.0859Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M152.552 42.8092C152.552 42.8092 151.281 38.4571 146.866 37.4055C142.451 36.3539 136.476 39.0234 136.476 39.0234C136.476 39.0234 140.955 43.3027 145.185 44.686C149.415 46.0693 152.552 42.8092 152.552 42.8092Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    opacity: 0.3,
    d: "M152.552 42.8092C152.552 42.8092 151.281 38.4571 146.866 37.4055C142.451 36.3539 136.476 39.0234 136.476 39.0234C136.476 39.0234 140.955 43.3027 145.185 44.686C149.415 46.0693 152.552 42.8092 152.552 42.8092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    d: "M144.389 24.4375C144.389 24.4375 139.885 24.5184 137.706 28.4822C135.527 32.4461 136.476 38.9985 136.476 38.9985C136.476 38.9985 141.767 35.7627 144.236 32.0739C146.705 28.3852 144.389 24.4375 144.389 24.4375Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    opacity: 0.3,
    d: "M144.389 24.4375C144.389 24.4375 139.885 24.5184 137.706 28.4822C135.527 32.4461 136.476 38.9985 136.476 38.9985C136.476 38.9985 141.767 35.7627 144.236 32.0739C146.705 28.3852 144.389 24.4375 144.389 24.4375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    d: "M181.583 82.7776C181.583 82.7776 181.623 87.3077 185.604 89.5323C189.584 91.7569 196.058 90.8589 196.058 90.8589C196.058 90.8589 192.914 85.5037 189.231 82.9879C185.547 80.4721 181.583 82.7776 181.583 82.7776Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    opacity: 0.3,
    d: "M181.583 82.7776C181.583 82.7776 181.623 87.3077 185.604 89.5323C189.584 91.7569 196.058 90.8589 196.058 90.8589C196.058 90.8589 192.914 85.5037 189.231 82.9879C185.547 80.4721 181.583 82.7776 181.583 82.7776Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M184.43 102.671C184.43 102.671 188.78 103.836 191.973 100.592C195.166 97.3479 195.994 90.8359 195.994 90.8359C195.994 90.8359 190.027 92.4538 186.641 95.3579C183.255 98.2621 184.43 102.671 184.43 102.671Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    opacity: 0.3,
    d: "M184.43 102.671C184.43 102.671 188.78 103.836 191.973 100.592C195.166 97.3479 195.994 90.8359 195.994 90.8359C195.994 90.8359 190.027 92.4538 186.641 95.3579C183.255 98.2621 184.43 102.671 184.43 102.671Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_84",
    d: "M240.827 120.718C240.827 120.718 236.847 118.607 233.019 121.05C229.191 123.493 226.907 129.657 226.907 129.657C226.907 129.657 233.083 129.415 237.032 127.352C240.98 125.289 240.827 120.718 240.827 120.718Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_85",
    opacity: 0.3,
    d: "M240.827 120.718C240.827 120.718 236.847 118.607 233.019 121.05C229.191 123.493 226.907 129.657 226.907 129.657C226.907 129.657 233.083 129.415 237.032 127.352C240.98 125.289 240.827 120.718 240.827 120.718Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_86",
    d: "M222.042 113.777C222.042 113.777 218.954 117.078 220.281 121.446C221.608 125.814 226.899 129.657 226.899 129.657C226.899 129.657 228.315 123.606 227.382 119.222C226.449 114.837 222.042 113.777 222.042 113.777Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_87",
    opacity: 0.3,
    d: "M222.042 113.777C222.042 113.777 218.954 117.078 220.281 121.446C221.608 125.814 226.899 129.657 226.899 129.657C226.899 129.657 228.315 123.606 227.382 119.222C226.449 114.837 222.042 113.777 222.042 113.777Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_88",
    d: "M190.775 60.9963C193.276 64.7012 194.233 70.8411 194.233 70.8411C194.233 70.8411 187.896 69.288 185.033 65.7448C182.17 62.2016 183.794 57.9708 183.794 57.9708C183.794 57.9708 188.282 57.2913 190.775 60.9963ZM183.883 71.5773C179.669 73.0172 179.13 77.5473 179.13 77.5473C179.13 77.5473 182.749 80.2491 186.898 78.4128C191.048 76.5765 194.233 70.8411 194.233 70.8411C194.233 70.8411 188.097 70.1373 183.883 71.5773Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_89",
    d: "M209.955 66.5125C205.564 67.2487 199.621 65.558 199.621 65.558C199.621 65.558 203.642 60.4131 208.073 59.2805C212.504 58.148 215.6 61.3919 215.6 61.3919C215.6 61.3919 214.346 65.7764 209.955 66.5125ZM203.28 55.7535C203.747 51.3044 199.878 48.918 199.878 48.918C199.878 48.918 195.93 51.094 195.857 55.6565C195.785 60.2189 199.629 65.5256 199.629 65.5256C199.629 65.5256 202.822 60.2432 203.28 55.7535Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_90",
    d: "M163.77 27.6244C161.647 31.564 156.661 35.2366 156.661 35.2366C156.661 35.2366 155.125 28.854 156.934 24.6718C158.744 20.4895 163.223 19.9961 163.223 19.9961C163.223 19.9961 165.893 23.693 163.77 27.6244ZM151.257 26.322C148.04 23.2157 143.802 24.8174 143.802 24.8174C143.802 24.8174 143.078 29.2909 146.609 32.1626C150.139 35.0344 156.661 35.2366 156.661 35.2366C156.661 35.2366 154.465 29.4284 151.257 26.322Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_91",
    d: "M126.705 51.644C124.582 55.5754 119.596 59.2561 119.596 59.2561C119.596 59.2561 118.06 52.8736 119.87 48.6832C121.679 44.4929 126.159 44.0156 126.159 44.0156C126.159 44.0156 128.829 47.7125 126.705 51.644ZM114.192 50.3416C110.976 47.2352 106.737 48.8369 106.737 48.8369C106.737 48.8369 106.014 53.3023 109.544 56.1741C113.074 59.0458 119.596 59.2561 119.596 59.2561C119.596 59.2561 117.401 53.4479 114.192 50.3416Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_92",
    d: "M78.9523 29.3959C81.4533 33.1008 82.4103 39.2407 82.4103 39.2407C82.4103 39.2407 76.0733 37.6876 73.2023 34.1444C70.3314 30.6012 71.9639 26.3785 71.9639 26.3785C71.9639 26.3785 76.4513 25.6909 78.9523 29.3959ZM72.0604 39.9769C67.8464 41.4168 67.3076 45.9469 67.3076 45.9469C67.3076 45.9469 70.9184 48.6488 75.0761 46.8124C79.2337 44.9761 82.4103 39.2407 82.4103 39.2407C82.4103 39.2407 76.2743 38.5369 72.0604 39.9769Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_93",
    d: "M209.794 93.0512C208.716 88.699 209.931 82.6077 209.931 82.6077C209.931 82.6077 215.343 86.2722 216.815 90.592C218.286 94.9117 215.311 98.3093 215.311 98.3093C215.311 98.3093 210.864 97.3952 209.794 93.0512ZM219.919 85.5199C224.374 85.6331 226.433 81.5722 226.433 81.5722C226.433 81.5722 223.972 77.7783 219.436 78.0533C214.901 78.3284 209.955 82.6077 209.955 82.6077C209.955 82.6077 215.447 85.3985 219.919 85.5199Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_94",
    d: "M95.1248 37.4215C90.7258 36.742 85.5951 33.2797 85.5951 33.2797C85.5951 33.2797 91.0475 29.6557 95.5751 29.955C100.103 30.2543 102.081 34.3152 102.081 34.3152C102.081 34.3152 99.5317 38.093 95.1248 37.4215ZM92.101 25.1418C93.9185 21.097 90.9751 17.5781 90.9751 17.5781C90.9751 17.5781 86.5521 18.3871 85.0643 22.723C83.5766 27.059 85.5951 33.2393 85.5951 33.2393C85.5951 33.2393 90.2835 29.2269 92.101 25.1418Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_95",
    d: "M10.162 109.674C14.4564 108.501 20.5441 109.585 20.5441 109.585C20.5441 109.585 17.0218 115.11 12.7596 116.688C8.49735 118.265 5.05542 115.337 5.05542 115.337C5.05542 115.337 5.86765 110.847 10.162 109.674ZM17.8662 119.657C17.8662 124.138 21.9353 126.128 21.9353 126.128C21.9353 126.128 25.6507 123.564 25.2808 119.018C24.9108 114.471 20.5441 109.577 20.5441 109.577C20.5441 109.577 17.8903 115.199 17.8662 119.657Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_96",
    d: "M248.789 18.6604C248.717 23.1339 245.999 28.7156 245.999 28.7156C245.999 28.7156 241.696 23.7811 241.375 19.2267C241.053 14.6723 244.792 12.1484 244.792 12.1484C244.792 12.1484 248.87 14.187 248.789 18.6604ZM237.104 23.3442C232.834 22.0823 229.802 25.4879 229.802 25.4879C229.802 25.4879 231.226 29.7834 235.673 30.6814C240.12 31.5793 245.999 28.7156 245.999 28.7156C245.999 28.7156 241.375 24.5981 237.104 23.3442Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_97",
    d: "M36.1936 142.715C35.3334 142.804 34.5085 143.107 33.7928 143.595C33.0771 144.084 32.4929 144.743 32.0923 145.514C30.8297 148.119 31.6419 152.204 31.6419 152.204C31.6419 152.204 34.8587 150.003 36.3384 147.569C36.7449 146.819 36.9458 145.975 36.9204 145.122C36.8949 144.269 36.6441 143.438 36.1936 142.715Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_98",
    opacity: 0.3,
    d: "M36.1936 142.715C35.3334 142.804 34.5085 143.107 33.7928 143.595C33.0771 144.084 32.4929 144.743 32.0923 145.514C30.8297 148.119 31.6419 152.204 31.6419 152.204C31.6419 152.204 34.8587 150.003 36.3384 147.569C36.7449 146.819 36.9458 145.975 36.9204 145.122C36.8949 144.269 36.6441 143.438 36.1936 142.715Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_99",
    d: "M172.737 158.91C171.876 158.998 171.05 159.298 170.333 159.785C169.616 160.272 169.03 160.93 168.628 161.701C167.373 164.306 168.177 168.391 168.177 168.391C168.177 168.391 171.394 166.191 172.882 163.756C173.288 163.008 173.488 162.165 173.463 161.313C173.437 160.462 173.187 159.632 172.737 158.91Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_100",
    opacity: 0.3,
    d: "M172.737 158.91C171.876 158.998 171.05 159.298 170.333 159.785C169.616 160.272 169.03 160.93 168.628 161.701C167.373 164.306 168.177 168.391 168.177 168.391C168.177 168.391 171.394 166.191 172.882 163.756C173.288 163.008 173.488 162.165 173.463 161.313C173.437 160.462 173.187 159.632 172.737 158.91Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_101",
    d: "M13.7971 224.457C12.9369 224.546 12.112 224.849 11.3963 225.337C10.6806 225.826 10.0964 226.485 9.69578 227.256C8.4332 229.861 9.24544 233.946 9.24544 233.946C9.24544 233.946 12.4622 231.746 13.9419 229.311C14.3436 228.56 14.5417 227.716 14.5163 226.864C14.4909 226.012 14.2429 225.182 13.7971 224.457Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_102",
    opacity: 0.3,
    d: "M13.7971 224.457C12.9369 224.546 12.112 224.849 11.3963 225.337C10.6806 225.826 10.0964 226.485 9.69578 227.256C8.4332 229.861 9.24544 233.946 9.24544 233.946C9.24544 233.946 12.4622 231.746 13.9419 229.311C14.3436 228.56 14.5417 227.716 14.5163 226.864C14.4909 226.012 14.2429 225.182 13.7971 224.457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_103",
    d: "M180.135 87.3003C179.357 86.9208 178.497 86.7414 177.632 86.7781C176.768 86.8148 175.926 87.0665 175.182 87.5106C172.769 89.0638 171.305 92.9629 171.305 92.9629C171.305 92.9629 175.222 92.8092 177.739 91.4987C178.473 91.0762 179.082 90.4645 179.503 89.7265C179.925 88.9886 180.143 88.1511 180.135 87.3003Z",
    fill: "#FE9F44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_104",
    opacity: 0.3,
    d: "M180.135 87.3003C179.357 86.9208 178.497 86.7414 177.632 86.7781C176.768 86.8148 175.926 87.0665 175.182 87.5106C172.769 89.0638 171.305 92.9629 171.305 92.9629C171.305 92.9629 175.222 92.8092 177.739 91.4987C178.473 91.0762 179.082 90.4645 179.503 89.7265C179.925 88.9886 180.143 88.1511 180.135 87.3003Z",
    fill: "black"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.145241050e8f07201fac3cb328b08dbf.svg";
export { ForwardRef as ReactComponent };